import { render, staticRenderFns } from "./PermissionsCartable.vue?vue&type=template&id=6a8523b9&scoped=true&"
import script from "./PermissionsCartable.vue?vue&type=script&lang=js&"
export * from "./PermissionsCartable.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsCartable.vue?vue&type=style&index=0&id=6a8523b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8523b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VIcon,VRow,VSkeletonLoader})
